// extracted by mini-css-extract-plugin
export default {"container":"aZ67M","item":"ibH85","separator":"MeV-p","link":"_0+FZZ"};